export enum EnergyEfficiencyVersion {
  OLD_VERSION = 1,
  NEW_VERSION = 2
}
